import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import ExclusiveSelection from "./ExclusiveSelection";
import MultipleSelection from "./MultipleSelection";
import ToggleButtonSize from "./ToggleButtonSize";
import ToggleButtonColor from "./ToggleButtonColor";
import VerticalToggleButtons from "./VerticalToggleButtons";

const ToggleButtonPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Toggle Button"}
        description={"A Toggle Button can be used to group related options."}
      />
      <Divider light />

      <ExclusiveSelection />
      <MultipleSelection />
      <ToggleButtonSize />
      <ToggleButtonColor />
      <VerticalToggleButtons />
    </Paper>
  );
};

export default ToggleButtonPage;
